import { Component, Input, SimpleChanges } from '@angular/core';
import { UserType } from "@shared-features/enums/user-type.enum";
import { Shipment } from '@shared-features/models/shipment';
import { ShipmentAction } from "@shared-features/enums/shipment-action.enum";
@Component({
  selector: 'app-gate-to-gate',
  templateUrl: './gate-to-gate.component.html',
  styleUrls: ['./gate-to-gate.component.scss'],
})
export class GateToGateComponent {
  @Input() shipment: Shipment = new Shipment();
  ShipmentAction = ShipmentAction;
  loadingOffTime: string;
  droppingOffTime: string;
  constructor() {}

  public get UserType(): typeof UserType {
    return UserType;
  }

  timeConvert(n: number) {
    const hours = Math.floor(n);
    const min = Math.round((n - hours) * 60);
    return +hours + ' hour(s) and ' + min + ' minute(s).';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shipment && changes.shipment.currentValue) {
      this.loadingOffTime = this.timeConvert(this.shipment?.loadingOffTime) || '0';
      this.droppingOffTime = this.timeConvert(this.shipment?.droppingOffTime) || '0';
    }
  }
}
